import { Record } from "immutable";
import moment from "../utils/moment";

const WalletJournalRecord = new Record({
  id: undefined,
  money: undefined,
  fee: undefined,
  time: undefined,
  comment: "",
  status: undefined,
  act_url: undefined
});

export default class Invoice extends WalletJournalRecord {
  getTime() {
    return moment(this.time).format("Y-DD-MM, HH:mm");
  }

  getStatusText() {
    if (this.status == "created") {
      return "Сформирован";
    }
    if (this.status == "on_payment") {
      return "На оплате";
    }
    if (this.status == "paid") {
      return "Оплачен";
    }

    return "???";
  }

  getStatusTitle() {
    if (this.status == "created") {
      return "Проверка сформированного счета для оплаты";
    }
    if (this.status == "on_payment") {
      return "Оплата будет произведена в течении 1-3 дней.";
    }
    if (this.status == "paid") {
      return "Оплата прошла успешно.";
    }

    return "???";
  }
}
